<ul>
  <ng-content></ng-content>
</ul>
